import React, {useState} from "react"
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {InfoSubmitEvent} from "../../Containers/RootContainer";
import PrivacyPolicy from "./Common/PrivacyPolicy";
import UserInfoForm from "./Common/UserInfoForm";

interface AskUserInfoProps {
    prefill: InfoSubmitEvent,
    onSubmitInfo: (info: InfoSubmitEvent) => void,
    onBack: () => void,
}

const AskUserInfo = ({ prefill, onSubmitInfo, onBack }: AskUserInfoProps) => {
    const { t } = useTranslation()

    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState<boolean>(false)
    const [values, setValues] = useState<InfoSubmitEvent>(prefill);

    const isReadyToSend = (values: InfoSubmitEvent) => {
        const {
            acceptTermsOfUse,
            firstName,
            lastName,
            email,
            phone,
        } = values
        return acceptTermsOfUse &&
            firstName !== '' &&
            lastName !== '' &&
            email !== '' &&
            phone !== ''
    }

    return (
        showPrivacyPolicy === false ?
            <UserInfoForm
                header={<Typography variant="h3" gutterBottom>{t('selfService.askUserInformation')}</Typography>}
                prefill={values}
                onSubmitInfo={onSubmitInfo}
                onBack={onBack}
                isReadyToSend={isReadyToSend}
                setShowPrivacyPolicy={setShowPrivacyPolicy}
                onChange={setValues}
            />
            :
            <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
    )
}

export default AskUserInfo
